export class NumberToBootstrapSizeBaseValueConverter {
    toView(value) {
        let valueToNumber = Number.parseInt(value);
        switch(valueToNumber) {
            case 1: return 'col-lg-12 col-md-12 col-sm-12 col-xs-12';
            case 2: return 'col-lg-6 col-md-6 col-sm-12 col-xs-12';
            case 3: return 'col-lg-4 col-md-4 col-sm-12 col-xs-12';
            case 4: return 'col-lg-3 col-md-3 col-sm-12 col-xs-12';
            // case 6: return 'col-lg-2 col-md-2 col-sm-6 col-xs-12';
            // case 12: return 'col-lg-1 col-md-1 col-sm-12 col-xs-12';
        }
    }
}